import {useSelector} from 'react-redux';
import {MainAssetSlide} from './MainAssetSlide';

export const PremiumDesign = (props) => {
  const {
    invitation,
    isWebview,
    yourInvitationRef,
    yourInvitationSizeRef,
    inviteContainerRef,
    desktopInviteRef,
    envelopeWidthRef,
    designTemplateRef,
    fabricCardRef,
    stickerContainerRef,
    height,
    preview,
    fabricArt,
  } = props;
  const envelope = useSelector((state) => state.premiumDesign.envelope);
  const stamp = useSelector((state) => state.premiumDesign.stamp);
  const liner = useSelector((state) => state.premiumDesign.liner);
  const hasRsvpd = useSelector((state) => state.rsvp?.hasRsvpd);
  const guestName = useSelector((state) => state.user.name);
  const origin = useSelector((state) => state.eventDetails.origin);
  const envelopeStickers = useSelector((state) => state.premiumDesign.envelopeStickers);

  const isLotti = !!(
    invitation.bodymovinAnimation &&
    invitation.renderedTextImg &&
    invitation.renderedTextImg.length > 8 &&
    !evite.detects.isIE &&
    !evite.detects.isEdge
  );

  return (
    <div className="premium-design__container">
      <MainAssetSlide
        {...{
          isWebview,
          guestName,
          invitation,
          fabricArt,
          envelope,
          stamp,
          isLotti,
          liner,
          designTemplateRef,
          height,
          isMobile: true,
          hasRsvpd,
          yourInvitationRef,
          yourInvitationSizeRef,
          inviteContainerRef,
          desktopInviteRef,
          envelopeWidthRef,
          fabricCardRef,
          stickerContainerRef,
          origin,
          preview,
          envelopeStickers,
        }}
      />
    </div>
  );
};
